import type { ComponentType } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import mapStateToProps from './query.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default function (WrappedComponent: ComponentType<any>) {
	return connect(mapStateToProps, {})(WrappedComponent);
}
